import { definePanel } from '@/app/definePanel';
import { UsersIcon } from '@/components/occurra/icons/UsersIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'users',
    title: 'Users',
    description: 'Who can sign in, and what each of them is permitted to do.',
    icon: UsersIcon,
    width: { min: 240, default: 240, max: Infinity, fill: false },
    modes: [PanelMode.Settings],
    themes: PanelTheme.Any,
    order: 3.75,
    // After Organization settings in the rail, before the rules.
    navOrder: 3.5,
    // Opening the list brings its detail surface along in the same commit
    // (rightmost/no-displacement gated — see resolveAutoChild).
    autoChild: 'user_details',
    // userId lives in this panel's local props in localStorage (not URL-synced).
    urlSyncedProps: [],
});
